import { useEffect, useState } from "react";
import { useAuth } from "./AuthProvider";

/** Whether the signed-in user can open /admin (asked to the API, which owns the ADMIN_EMAILS list). */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const userId = user?.id ?? null;

  useEffect(() => {
    setIsAdmin(false);
    if (!userId) return;
    const ctrl = new AbortController();
    fetch("/api/admin/whoami", { credentials: "same-origin", signal: ctrl.signal })
      .then((r) => setIsAdmin(r.ok))
      .catch(() => {});
    return () => ctrl.abort();
  }, [userId]);

  return isAdmin;
}
